
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  CartesianGrid,
  ResponsiveContainer,
  LabelList,
  Area,
  ComposedChart,
} from "recharts";

// ✅ Custom Label for Bars
const CustomLabel = ({ x, y, value, dataKey}) => {
  return (
    <text
      x={x}
      y={y - 5}
      textAnchor="middle"
      fontSize={12}
      fill="#fff"
      opacity={10000}
    >
      {value} K
    </text>
  );
};

  function formatNumber(num) {
      if (num >= 1_000_000_000) {
          const val = Math.floor(num / 100_000_000) / 10;
          return val + 'B';
      }
      if (num >= 1_000_000) {
          const val = Math.floor(num / 100_000) / 10;
          return val + 'M';
      }
      if (num >= 1_000) {
          const val = Math.floor(num / 100) / 10;
          return val + 'K';
      }
      return num.toString();
  }

const TopLabel = ({ x, y, value, dataKey }) => {
  if (x == null || y == null) return null;
  const text = dataKey === "bookedCN" ? `${value}` : `${formatNumber(value)}`;
  // y-8 places label above the bar/area top; tweak if you need more spacing
  return (
    <text
      x={x}
      y={y - 12}
      textAnchor="middle"
      fill="#fff"
      fontWeight="700"
      pointerEvents="none"
      style={{margin: '5px'}}
    >
      {text}
    </text>
  );
};

const tooltipFormatter = (value, name, item) => {
    // Access dataKey from the item object
    const dataKey = item.dataKey;
    const text = dataKey === "bookedCN" ? `${value}` :`${formatNumber(value)}`;
    return [`${text}`, name];
  };


export default function BusinessSummaryChart({businessSummary : data}) {
  return (
    <div
      style={{
        background: "linear-gradient(to bottom, #666, #555)",
        borderRadius: "15px",
        padding: "20px",
        width: "100%",
        height: "400px",
      }}
    >
      {/* <h3
        style={{
          textAlign: "center",
          color: "white",
          marginBottom: "10px",
          fontWeight: "bold",
        }}
      >
        Business Summary
      </h3> */}

      <ResponsiveContainer width="100%" height="100%">
        <ComposedChart
          data={data}
          margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
        >
          <CartesianGrid
            strokeDasharray="3 2"
            vertical={false}
            stroke="rgba(255,255,255,0.1)"
          />
          <XAxis dataKey="month" stroke="#fff" />
          <YAxis stroke="#fff" hide />
          <Tooltip  formatter={tooltipFormatter}  />
          <Legend wrapperStyle={{ color: "#fff" }} />

          {/* Background Area */}
          <Area
            type="monotone"
            dataKey="bookedCN"
            name="Booked"
            stroke="none"
            fill="url(#areaGrad)"
            color="black"
          >
            {/* <LabelList  dataKey="bookedCN" fill="white" position="left"  /> */}
          </Area>

          <Bar
            dataKey="receivedAmount"
            name="COD Amount"
            fill="url(#lightOrangeGrad)"
            barSize={15}
            radius={[5, 5, 0, 0]}
          >
            {/* <LabelList dataKey="receivedAmount" fill="white" position="left"   /> */}
          </Bar>

          <Bar
            dataKey="shippingCharges"
            name="Shipping Charges"
            fill="url(#grayGrad)"
            barSize={15}
            radius={[5, 5, 0, 0]}
          >
            {/* <LabelList   dataKey="shippingCharges" fill="white" position="left" color="black" /> */}
          </Bar>

          {/* Gradients */}
          <defs>
            <linearGradient id="lightOrangeGrad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#FFB088" />
              <stop offset="100%" stopColor="#FF7C47" />
            </linearGradient>
            <linearGradient id="grayGrad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#ddd" />
              <stop offset="100%" stopColor="#999" />
            </linearGradient>
            <linearGradient id="areaGrad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#faa98aff" stopOpacity={1} />
              <stop offset="100%" stopColor="#ff8c5fff" stopOpacity={0} />
            </linearGradient>
          </defs>
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
}






// const TopLabel = ({ x, y, value, dataKey }) => {
//   if (x == null || y == null) return null;
//   const text = dataKey === "bookedCN" ? `${value}` : `${value} K`;
//   // y-8 places label above the bar/area top; tweak if you need more spacing
//   return (
//     <text
//       x={x}
//       y={y - 12}
//       textAnchor="middle"
//       fill="#fff"
//       fontWeight="700"
//       pointerEvents="none"
//       style={{margin: '5px'}}
//     >
//       {text}
//     </text>
//   );
// };

// const renderCustomBarLabel = ({ payload, x, y, width, height, value }) => {
//   return <text x={x + width / 2} y={y} fill="orange" textAnchor="middle" dy={-6}>{`value: ${value}`}</text>;
// };

// export default function BusinessSummaryChart({ businessSummary: data }) {
//   return (
//     <div
//       style={{
//         background: "linear-gradient(to bottom, #666, #555)",
//         borderRadius: "15px",
//         padding: "20px",
//         width: "100%",
//         height: "420px",
//       }}
//     >
//       <h3 style={{ textAlign: "center", color: "#fff", marginBottom: 10 }}>
//         Business Summary
//       </h3>

//       <ResponsiveContainer width="100%" height="90%">
//         <ComposedChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 20 }}>
//           <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="rgba(255,255,255,0.08)" />
//           <XAxis dataKey="month" stroke="#fff" />
//           <YAxis stroke="#fff" hide />
//           <Tooltip formatter={(v) => `${v} K`} />
//           <Legend wrapperStyle={{ color: "#fff" }} />

//           {/* area (BOOKED) drawn first (under bars) */}
//           <defs>
//             <linearGradient id="areaGrad" x1="0" y1="0" x2="0" y2="1">
//               <stop offset="0%" stopColor="#FF7C47" stopOpacity={0.35} />
//               <stop offset="100%" stopColor="#FF7C47" stopOpacity={0} />
//             </linearGradient>

//             <linearGradient id="lightOrangeGrad" x1="0" y1="0" x2="0" y2="1">
//               <stop offset="0%" stopColor="#FFB088" />
//               <stop offset="100%" stopColor="#FF7C47" />
//             </linearGradient>

//             <linearGradient id="grayGrad" x1="0" y1="0" x2="0" y2="1">
//               <stop offset="0%" stopColor="#ddd" />
//               <stop offset="100%" stopColor="#999" />
//             </linearGradient>
//           </defs>

//           <Area type="monotone" dataKey="bookedCN" name="Booked" stroke="none" fill="url(#areaGrad)" />

//           {/* visible bars */}
//           <Bar dataKey="receivedAmount" name="COD Received" fill="url(#lightOrangeGrad)" barSize={18} radius={[6, 6, 0, 0]} />
//           <Bar dataKey="shippingCharges" name="Shipping Charges" fill="url(#grayGrad)" barSize={18} radius={[6, 6, 0, 0]} />

//           {/* ---------- overlay invisible bars (rendered AFTER shapes) ---------- */}
//           {/* These have transparent fill but provide coordinates for LabelList.
//               Because they are declared last, their LabelList text is painted on top. */}

//           <Bar dataKey="bookedCN" fill="transparent" barSize={0} isAnimationActive={false}  label={renderCustomBarLabel}>
//             <LabelList
//               dataKey="bookedCN"
//               content={(props) => <TopLabel {...props} dataKey="bookedCN" />}
//             />
//           </Bar>

//           <Bar dataKey="receivedAmount" fill="transparent" barSize={0} isAnimationActive={false}  label={renderCustomBarLabel}>
//             <LabelList

//               dataKey="receivedAmount"
//               content={(props) => <TopLabel {...props} dataKey="receivedAmount" />}
//             />
//           </Bar>

//           <Bar dataKey="shippingCharges" fill="transparent" barSize={0} isAnimationActive={false}  label={renderCustomBarLabel}>
//             <LabelList

//               dataKey="shippingCharges"
//               content={(props) => <TopLabel {...props} dataKey="shippingCharges" />}
//             />
//           </Bar>
//           {/* ------------------------------------------------------------------- */}
//         </ComposedChart>
//       </ResponsiveContainer>
//     </div>
//   );
// }